import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import type { TFunction } from 'i18next'
import { formatAgendaWhen } from '../format'
import { responseKey, type AgendaListItem, type AgendaResponse } from '../types'
import { timeOf, type DayEvent } from '../week'

/** Yanıt → çip görünümü: bekleniyor kesikli, katılıyor dolu, katılmıyor soluk. */
const RESPONSE_CLASS: Record<AgendaResponse, string> = {
  PENDING: 'agenda-chip--pending',
  ATTENDING: 'agenda-chip--attending',
  NOT_ATTENDING: 'agenda-chip--declined',
}

/** Çip sınıfı: yanıt varsa ona göre; yoksa (katılımcı olmayan sahip) "düzenleyen" görünümü. */
function chipClass(item: AgendaListItem): string {
  const classes = ['agenda-chip']
  if (item.myResponse) classes.push(RESPONSE_CLASS[item.myResponse] ?? RESPONSE_CLASS.PENDING)
  else if (item.owner) classes.push('agenda-chip--owner')
  else classes.push(RESPONSE_CLASS.PENDING)
  if (item.owner) classes.push('agenda-chip--mine')
  return classes.join(' ')
}

/** Ekran okuyucu için durum: "Düzenleyen", yanıt, "Tekrarlı" — hangileri varsa. */
function statusText(t: TFunction, item: AgendaListItem): string {
  const parts: string[] = []
  if (item.owner) parts.push(t('agenda.organizerBadge'))
  if (item.myResponse) parts.push(t(responseKey(item.myResponse)))
  if (item.seriesId != null) parts.push(t('agenda.recurrence.chip'))
  return parts.join(', ')
}

interface Props {
  event: DayEvent
  /** Takvimin adresi (hafta dahil) — detaydaki "Ajandaya Dön" aynı haftaya döner. */
  from: string
}

/**
 * Takvimde bir toplantı: "SS:DD Başlık", detaya giden gerçek `<Link>`. Çok günlü toplantının devam
 * günlerinde saat yerine "…" yazar (00:00 gerçek başlangıç değildir).
 */
export default function EventChip({ event, from }: Readonly<Props>) {
  const { t } = useTranslation()
  const { item, continued } = event
  const label = t('agenda.week.chipLabel', {
    title: item.title,
    when: formatAgendaWhen(item.startTime, item.endTime),
    status: statusText(t, item),
  })

  return (
    <Link
      to={`/minutes/agenda/${item.id}`}
      state={{ from }}
      className={chipClass(item)}
      aria-label={label}
      title={label}
    >
      <span className="agenda-chip-time">{continued ? '…' : timeOf(item.startTime)}</span>
      {item.owner && <i className="pi pi-user agenda-chip-owner" aria-hidden="true" />}
      {item.seriesId != null && <i className="pi pi-sync agenda-chip-series" aria-hidden="true" />}
      <span className="agenda-chip-title">{item.title}</span>
    </Link>
  )
}
